import React, { Component } from 'react';
import * as validators from 'utils/validators';
import InputField from 'components/InputField';
import AlertDialog from 'components/AlertDialog';
import { Field } from 'redux-form';
import DateTimeField from 'components/DateTimeField';
import * as actions from 'modules/account';
import ShopifyLocationsSelectField from 'components/ShopifyLocationsField';
import CollapsablePanel from './CollapsePanel';


class Location extends Component {

    showRevertDialog() {
        this.dialogConfirmRevert.show();
    }


    closeConfirmRevertDialog() {
        this.dialogConfirmRevert.hide();
    }


    revertSystem() {
        let { dispatch, location } = this.props;

        dispatch(actions.revertSystem(location.currentInvoiceDate, location.locationId));
    }

    render() {
        let { el, location, showLabels, onClick, idx } = this.props;
        let { accounting, taxes } = location;

        return (<div>
            <div className="location-panel">
                {!showLabels && <section>
                    <h4 style={{ textAlign: "right" }}>#{idx + 1}{" "}<i className="fa fa-times-circle location-panel-remove" title="Remove location" onClick={onClick}></i></h4>

                    <div className="form-group">
                        <div className="checkbox">
                            <label htmlFor={`${el}.enabled`}><Field parse={value => !!value} name={`${el}.enabled`} id={`${el}.enabled`} component="input" type="checkbox" />Enabled</label>
                            <p>Invoices are not issued automatically if location is disabled.</p>
                        </div>
                    </div>


                    <div className="form-group">
                        <label htmlFor={`${el}.company`}>Location Name</label>
                        <Field id={`${el}.company`} name={`${el}.locationId`} component={ShopifyLocationsSelectField} validate={[validators.required]} />
                    </div>

                    {/* <div className="form-group">
                        <div className="checkbox">
                            <label htmlFor={`${el}.default`}><Field parse={value => !!value} name={`${el}.default`} id={`${el}.default`} component="input" type="checkbox" />Use this location for all orders</label>
                        </div>
                    </div> */}
                </section>}
                {!showLabels && <CollapsablePanel location="default" section="company" title="Company Information">

                    <div className="form-group">
                        <label htmlFor={`${el}.company`}>Name</label>

                        <Field
                            className="form-control"
                            name={`${el}.company`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.website`}>Website</label>

                        <Field
                            className="form-control"
                            name={`${el}.website`}
                            component={InputField}
                            type="text"
                            validate={[validators.url]}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.registrationNumber`}>Registration Number</label>

                        <Field
                            className="form-control"
                            name={`${el}.registrationNumber`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.taxId`}>Tax Id</label>

                        <Field
                            className="form-control"
                            name={`${el}.taxId`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    Address
                <div className="form-group">
                        <label htmlFor={`${el}.address.street`}>Street Name</label>

                        <Field
                            className="form-control"
                            name={`${el}.address.street`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.address.number`}>Street Number</label>

                        <Field
                            className="form-control"
                            name={`${el}.address.number`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.address.zip`}>Zip</label>

                        <Field
                            className="form-control"
                            name={`${el}.address.zip`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.address.city`}>City</label>

                        <Field
                            className="form-control"
                            name={`${el}.address.city`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.address.region`}>Region</label>

                        <Field
                            className="form-control"
                            name={`${el}.address.region`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.address.country`}>Country</label>

                        <Field
                            className="form-control"
                            name={`${el}.address.country`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    Banking Information
                <div className="form-group">
                        <label htmlFor={`${el}.bank.name`}>Bank Name</label>

                        <Field
                            className="form-control"
                            name={`${el}.bank.name`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.bank.swift`}>Swift</label>

                        <Field
                            className="form-control"
                            name={`${el}.bank.swift`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.bank.currency`}>Currency</label>

                        <Field
                            className="form-control"
                            name={`${el}.bank.currency`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.bank.iban`}>IBAN</label>

                        <Field
                            className="form-control"
                            name={`${el}.bank.iban`}
                            component={InputField}
                            type="text"
                        />
                    </div>
                </CollapsablePanel>
                }
                {!showLabels && <CollapsablePanel location="default" section="invoicing" title="Invoicing">
                <div className="form-group">
                        <label htmlFor={`${el}.decimalPlaces`}>Decimal Places</label>

                        <Field
                            className="form-control"
                            name={`${el}.decimalPlaces`}
                            component={InputField}
                            type="text"
                            defaultValue={location.decimalPlaces}
                            validate={[validators.positive_num]}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor={`${el}.invoicePrefix`}>Invoices Prefix</label>

                        <Field
                            className="form-control"
                            name={`${el}.invoicePrefix`}
                            component={InputField}
                            type="text"
                            validate={[validators.required, validators.prefix]}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.currentInvoiceNumber`}>Current Invoice Number</label>

                        <Field
                            className="form-control"
                            name={`${el}.currentInvoiceNumber`}
                            component={InputField}
                            type="text"
                            defaultValue={location.currentInvoiceNumber}
                            validate={[validators.num]}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor={`${el}.creditNotePrefix`}>Credit Notes Prefix</label>

                        <Field
                            className="form-control"
                            name={`${el}.creditNotePrefix`}
                            component={InputField}
                            type="text"
                            validate={[validators.required]}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor={`${el}.currentCreditNoteNumber`}>Current Credit Note Number</label>

                        <Field
                            className="form-control"
                            name={`${el}.currentCreditNoteNumber`}
                            component={InputField}
                            type="text"
                            defaultValue={location.currentInvoiceNumber}
                            validate={[validators.num]}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor={`${el}.currentInvoiceDate`}>Last Invoice Date</label>
                        {location.currentInvoiceDate ?
                            <div>
                                <Field
                                    className="form-control"
                                    name={`${el}.currentInvoiceDate`}
                                    component={DateTimeField}
                                    type="text"
                                    defaultValue={new Date(location.currentInvoiceDate)}
                                    validate={[validators.required]}
                                />
                                <AlertDialog
                                    ref={instance => {
                                        this.dialogConfirmRevert = instance
                                    }}
                                    onOk={this.revertSystem.bind(this)}
                                    onClose={this.closeConfirmRevertDialog}
                                    dialogTitle={'Confirm Reverting System'}
                                    message={'All the invoices and their storno issued after this date will be removed. Continue with reverting the system?'}
                                    closeButtonLabel={'Cancel'}
                                    submitButtonLabel={'Revert'} />
                                <button type="button" className="btn btn-sm btn-danger" onClick={this.showRevertDialog.bind(this)}>{location.reverting ? "Reverting system, please wait..." : "Revert to this date"}</button>
                            </div>
                            : <i> No invoices created yet.</i>}
                    </div>
                    <div className="form-group">
                        <div className="checkbox">
                            <label htmlFor={`${el}.showVTA`}><Field parse={value => !!value} name={`${el}.showVTA`} id={`${el}.showVTA`} component="input" type="checkbox" />Show VAT</label>
                        </div>

                        <div className="checkbox">
                            <label htmlFor={`${el}.useOrderNumbering`}><Field parse={value => !!value} name={`${el}.useOrderNumbering`} id={`${el}.useOrderNumbering`} component="input" type="checkbox" />Use Order Numbering</label>
                        </div>

                        <div className="checkbox">
                            <label htmlFor={`${el}.convertPricesToBuyerCurrency`}><Field parse={value => !!value} name={`${el}.convertPricesToBuyerCurrency`} id={`${el}.convertPricesToBuyerCurrency`} component="input" type="checkbox" />Convert prices to the currency in which customer pays</label>
                        </div>


                        <div className="checkbox">
                            <label htmlFor={`${el}.taxes.override`}><Field parse={value => !!value} name={`${el}.taxes.override`} id={`${el}.taxes.override`} component="input" type="checkbox" />Override Taxes</label>
                            {
                                taxes && taxes.override && <section>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor={`${el}.taxes.taxesIncluded`}>
                                                    <Field parse={value => !!value} name={`${el}.taxes.taxesIncluded`} id={`${el}.taxes.taxesIncluded`} component="input" type="checkbox" />Prices have tax included
                                                        </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor={`${el}.taxes.productsRate`}>Products Tax Rate
                                                <Field
                                                        className="form-control"
                                                        name={`${el}.taxes.productsRate`}
                                                        component={InputField}
                                                        type="number"
                                                        validate={[validators.positive_num]}
                                                    /></label>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor={`${el}.taxes.shippingRate`}>Shipping Tax Rate
                                                            <Field
                                                        className="form-control"
                                                        name={`${el}.taxes.shippingRate`}
                                                        component={InputField}
                                                        type="number"
                                                        validate={[validators.positive_num]}
                                                    /></label>
                                            </div>
                                        </div>


                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">

                                            <div className="form-group">
                                                <label htmlFor={`${el}.taxes.skus`}>SKUs separated by semicolon
                                                            <Field
                                                        placeholder="1234;2345;"
                                                        className="form-control"
                                                        name={`${el}.taxes.skus`}
                                                        component={InputField}
                                                        type="text"
                                                    />
                                                </label>
                                                <label htmlFor={`${el}.taxes.skuRate`}>SKUs Tax Rate
                                                            <Field
                                                        className="form-control"
                                                        name={`${el}.taxes.skuRate`}
                                                        component={InputField}
                                                        validate={[validators.positive_num]}
                                                        type="number"
                                                    /></label>
                                            </div>

                                        </div>
                                    </div>
                                </section>
                            }
                        </div>
                    </div>

                    <label htmlFor={`${el}.accounting.country`}>Country</label>
                    <Field className="form-control" name={`${el}.accounting.country`} component="select">
                    <option value="AF">Afghanistan</option>
                                <option value="AX">Åland Islands</option>
                                <option value="AL">Albania</option>
                                <option value="DZ">Algeria</option>
                                <option value="AD">Andorra</option>
                                <option value="AO">Angola</option>
                                <option value="AI">Anguilla</option>
                                <option value="AG">Antigua &amp; Barbuda</option>
                                <option value="AR">Argentina</option>
                                <option value="AM">Armenia</option>
                                <option value="AW">Aruba</option>
                                <option value="AU">Australia</option>
                                <option value="AT">Austria</option>
                                <option value="AZ">Azerbaijan</option>
                                <option value="BS">Bahamas</option>
                                <option value="BH">Bahrain</option>
                                <option value="BD">Bangladesh</option>
                                <option value="BB">Barbados</option>
                                <option value="BY">Belarus</option>
                                <option value="BE">Belgium</option>
                                <option value="BZ">Belize</option>
                                <option value="BJ">Benin</option>
                                <option value="BM">Bermuda</option>
                                <option value="BT">Bhutan</option>
                                <option value="BO">Bolivia</option>
                                <option value="BA">Bosnia &amp; Herzegovina</option>
                                <option value="BW">Botswana</option>
                                <option value="BV">Bouvet Island</option>
                                <option value="BR">Brazil</option>
                                <option value="IO">British Indian Ocean Territory</option>
                                <option value="VG">British Virgin Islands</option>
                                <option value="BN">Brunei</option>
                                <option value="BG">Bulgaria</option>
                                <option value="BF">Burkina Faso</option>
                                <option value="BI">Burundi</option>
                                <option value="KH">Cambodia</option>
                                <option value="CM">Cameroon</option>
                                <option value="CA">Canada</option>
                                <option value="CV">Cape Verde</option>
                                <option value="BQ">Caribbean Netherlands</option>
                                <option value="KY">Cayman Islands</option>
                                <option value="CF">Central African Republic</option>
                                <option value="TD">Chad</option>
                                <option value="CL">Chile</option>
                                <option value="CN">China</option>
                                <option value="CX">Christmas Island</option>
                                <option value="CC">Cocos (Keeling) Islands</option>
                                <option value="CO">Colombia</option>
                                <option value="KM">Comoros</option>
                                <option value="CG">Congo - Brazzaville</option>
                                <option value="CD">Congo - Kinshasa</option>
                                <option value="CK">Cook Islands</option>
                                <option value="CR">Costa Rica</option>
                                <option value="CI">Côte d’Ivoire</option>
                                <option value="HR">Croatia</option>
                                <option value="CU">Cuba</option>
                                <option value="CW">Curaçao</option>
                                <option value="CY">Cyprus</option>
                                <option value="CZ">Czechia</option>
                                <option value="DK">Denmark</option>
                                <option value="DJ">Djibouti</option>
                                <option value="DM">Dominica</option>
                                <option value="DO">Dominican Republic</option>
                                <option value="EC">Ecuador</option>
                                <option value="EG">Egypt</option>
                                <option value="SV">El Salvador</option>
                                <option value="GQ">Equatorial Guinea</option>
                                <option value="ER">Eritrea</option>
                                <option value="EE">Estonia</option>
                                <option value="SZ">Eswatini</option>
                                <option value="ET">Ethiopia</option>
                                <option value="FK">Falkland Islands</option>
                                <option value="FO">Faroe Islands</option>
                                <option value="FJ">Fiji</option>
                                <option value="FI">Finland</option>
                                <option value="FR">France</option>
                                <option value="GF">French Guiana</option>
                                <option value="PF">French Polynesia</option>
                                <option value="TF">French Southern Territories</option>
                                <option value="GA">Gabon</option>
                                <option value="GM">Gambia</option>
                                <option value="GE">Georgia</option>
                                <option value="DE">Germany</option>
                                <option value="GH">Ghana</option>
                                <option value="GI">Gibraltar</option>
                                <option value="GR">Greece</option>
                                <option value="GL">Greenland</option>
                                <option value="GD">Grenada</option>
                                <option value="GP">Guadeloupe</option>
                                <option value="GT">Guatemala</option>
                                <option value="GG">Guernsey</option>
                                <option value="GN">Guinea</option>
                                <option value="GW">Guinea-Bissau</option>
                                <option value="GY">Guyana</option>
                                <option value="HT">Haiti</option>
                                <option value="HM">Heard &amp; McDonald Islands</option>
                                <option value="HN">Honduras</option>
                                <option value="HK">Hong Kong SAR China</option>
                                <option value="HU">Hungary</option>
                                <option value="IS">Iceland</option>
                                <option value="IN">India</option>
                                <option value="ID">Indonesia</option>
                                <option value="IR">Iran</option>
                                <option value="IQ">Iraq</option>
                                <option value="IE">Ireland</option>
                                <option value="IM">Isle of Man</option>
                                <option value="IL">Israel</option>
                                <option value="IT">Italy</option>
                                <option value="JM">Jamaica</option>
                                <option value="JP">Japan</option>
                                <option value="JE">Jersey</option>
                                <option value="JO">Jordan</option>
                                <option value="KZ">Kazakhstan</option>
                                <option value="KE">Kenya</option>
                                <option value="KI">Kiribati</option>
                                <option value="XK">Kosovo</option>
                                <option value="KW">Kuwait</option>
                                <option value="KG">Kyrgyzstan</option>
                                <option value="LA">Laos</option>
                                <option value="LV">Latvia</option>
                                <option value="LB">Lebanon</option>
                                <option value="LS">Lesotho</option>
                                <option value="LR">Liberia</option>
                                <option value="LY">Libya</option>
                                <option value="LI">Liechtenstein</option>
                                <option value="LT">Lithuania</option>
                                <option value="LU">Luxembourg</option>
                                <option value="MO">Macao SAR China</option>
                                <option value="MG">Madagascar</option>
                                <option value="MW">Malawi</option>
                                <option value="MY">Malaysia</option>
                                <option value="MV">Maldives</option>
                                <option value="ML">Mali</option>
                                <option value="MT">Malta</option>
                                <option value="MQ">Martinique</option>
                                <option value="MR">Mauritania</option>
                                <option value="MU">Mauritius</option>
                                <option value="YT">Mayotte</option>
                                <option value="MX">Mexico</option>
                                <option value="MD">Moldova</option>
                                <option value="MC">Monaco</option>
                                <option value="MN">Mongolia</option>
                                <option value="ME">Montenegro</option>
                                <option value="MS">Montserrat</option>
                                <option value="MA">Morocco</option>
                                <option value="MZ">Mozambique</option>
                                <option value="MM">Myanmar (Burma)</option>
                                <option value="NA">Namibia</option>
                                <option value="NR">Nauru</option>
                                <option value="NP">Nepal</option>
                                <option value="NL">Netherlands</option>
                                <option value="NC">New Caledonia</option>
                                <option value="NZ">New Zealand</option>
                                <option value="NI">Nicaragua</option>
                                <option value="NE">Niger</option>
                                <option value="NG">Nigeria</option>
                                <option value="NU">Niue</option>
                                <option value="NF">Norfolk Island</option>
                                <option value="KP">North Korea</option>
                                <option value="MK">North Macedonia</option>
                                <option value="NO">Norway</option>
                                <option value="OM">Oman</option>
                                <option value="PK">Pakistan</option>
                                <option value="PS">Palestinian Territories</option>
                                <option value="PA">Panama</option>
                                <option value="PG">Papua New Guinea</option>
                                <option value="PY">Paraguay</option>
                                <option value="PE">Peru</option>
                                <option value="PH">Philippines</option>
                                <option value="PN">Pitcairn Islands</option>
                                <option value="PL">Poland</option>
                                <option value="PT">Portugal</option>
                                <option value="QA">Qatar</option>
                                <option value="RE">Réunion</option>
                                <option value="RO">Romania</option>
                                <option value="RU">Russia</option>
                                <option value="RW">Rwanda</option>
                                <option value="WS">Samoa</option>
                                <option value="SM">San Marino</option>
                                <option value="ST">São Tomé &amp; Príncipe</option>
                                <option value="SA">Saudi Arabia</option>
                                <option value="SN">Senegal</option>
                                <option value="RS">Serbia</option>
                                <option value="SC">Seychelles</option>
                                <option value="SL">Sierra Leone</option>
                                <option value="SG">Singapore</option>
                                <option value="SX">Sint Maarten</option>
                                <option value="SK">Slovakia</option>
                                <option value="SI">Slovenia</option>
                                <option value="SB">Solomon Islands</option>
                                <option value="SO">Somalia</option>
                                <option value="ZA">South Africa</option>
                                <option value="GS">South Georgia &amp; South Sandwich Islands</option>
                                <option value="KR">South Korea</option>
                                <option value="SS">South Sudan</option>
                                <option value="ES">Spain</option>
                                <option value="LK">Sri Lanka</option>
                                <option value="BL">St. Barthélemy</option>
                                <option value="SH">St. Helena</option>
                                <option value="KN">St. Kitts &amp; Nevis</option>
                                <option value="LC">St. Lucia</option>
                                <option value="MF">St. Martin</option>
                                <option value="PM">St. Pierre &amp; Miquelon</option>
                                <option value="VC">St. Vincent &amp; Grenadines</option>
                                <option value="SD">Sudan</option>
                                <option value="SR">Suriname</option>
                                <option value="SJ">Svalbard &amp; Jan Mayen</option>
                                <option value="SE">Sweden</option>
                                <option value="CH">Switzerland</option>
                                <option value="SY">Syria</option>
                                <option value="TW">Taiwan</option>
                                <option value="TJ">Tajikistan</option>
                                <option value="TZ">Tanzania</option>
                                <option value="TH">Thailand</option>
                                <option value="TL">Timor-Leste</option>
                                <option value="TG">Togo</option>
                                <option value="TK">Tokelau</option>
                                <option value="TO">Tonga</option>
                                <option value="TT">Trinidad &amp; Tobago</option>
                                <option value="TN">Tunisia</option>
                                <option value="TR">Turkey</option>
                                <option value="TM">Turkmenistan</option>
                                <option value="TC">Turks &amp; Caicos Islands</option>
                                <option value="TV">Tuvalu</option>
                                <option value="UM">U.S. Outlying Islands</option>
                                <option value="UG">Uganda</option>
                                <option value="UA">Ukraine</option>
                                <option value="AE">United Arab Emirates</option>
                                <option value="GB">United Kingdom</option>
                                <option value="US">United States</option>
                                <option value="UY">Uruguay</option>
                                <option value="UZ">Uzbekistan</option>
                                <option value="VU">Vanuatu</option>
                                <option value="VA">Vatican City</option>
                                <option value="VE">Venezuela</option>
                                <option value="VN">Vietnam</option>
                                <option value="WF">Wallis &amp; Futuna</option>
                                <option value="EH">Western Sahara</option>
                                <option value="YE">Yemen</option>
                                <option value="ZM">Zambia</option>
                                <option value="ZW">Zimbabwe</option>
                                <option value="Other">Other</option>
                    </Field>
                    {/* {accounting && accounting.country === "RO" && <div>
                        <label htmlFor={`${el}.accounting.info.cont`}>Cod Cont Primar</label>
                        <Field
                            className="form-control"
                            name={`${el}.accounting.info.cont`}
                            component={InputField}
                            type="text"
                        />

                        <label htmlFor={`${el}.accounting.info.contc`}>Cod Cont Cheltuieli</label>
                        <Field
                            className="form-control"
                            name={`${el}.accounting.info.contc`}
                            component={InputField}
                            type="text"
                        />
                        <label htmlFor={`${el}.accounting.info.contv`}>Cod Cont Vanzari Marfa</label>
                        <Field
                            className="form-control"
                            name={`${el}.accounting.info.contv`}
                            component={InputField}
                            type="text"
                        />
                        <label htmlFor={`${el}.accounting.info.contvmrf`}>Cod Cont Vanzari Curier</label>
                        <Field
                            className="form-control"
                            name={`${el}.accounting.info.contvmrf`}
                            component={InputField}
                            type="text"
                        />

                        <label htmlFor={`${el}.accounting.info.ges`}>Cod Cont Gestiune</label>
                        <Field
                            className="form-control"
                            name={`${el}.accounting.info.ges`}
                            component={InputField}
                            type="text"
                        />
                    </div>} */}
                </CollapsablePanel>
                }
                {showLabels && <section>
                    <CollapsablePanel location="default" section="gls" title="EEU GLS">
                        <div className="form-group">
                            <div className="checkbox">
                                <label htmlFor={`${el}.gls.enabled`}><Field parse={value => !!value} name={`${el}.gls.enabled`} id={`${el}.gls.enabled`} component="input" type="checkbox" />Enabled</label>
                            </div>
                        </div>
                        {location.gls && location.gls.enabled && <div>
                            <div className="form-group">
                                <label htmlFor={`${el}.gls.sender_country`}>Country</label>


                                <Field className="form-control" name={`${el}.gls.sender_country`} component="select">
                                    <option value="HU">Hungary</option>
                                    <option value="SK">Slovakia</option>
                                    <option value="CZ">Czech</option>
                                    <option value="RO">Romania</option>
                                    <option value="SI">Slovenia</option>
                                    <option value="HR">Croatia</option>
                                </Field>

                            </div>

                            <div className="form-group">
                                <label htmlFor={`${el}.gls.senderid`}>Sender ID</label>

                                <Field
                                    className="form-control"
                                    name={`${el}.gls.senderid`}
                                    component={InputField}
                                    type="text"
                                    validate={[validators.required]}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor={`${el}.gls.username`}>Username</label>

                                <Field
                                    className="form-control"
                                    name={`${el}.gls.username`}
                                    component={InputField}
                                    type="text"
                                    validate={[validators.required]}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor={`${el}.gls.password`}>Password</label>

                                <Field
                                    className="form-control"
                                    name={`${el}.gls.password`}
                                    component={InputField}
                                    type="password"
                                    validate={[validators.required]}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor={`${el}.gls.sender_name`}>Name</label>

                                <Field
                                    className="form-control"
                                    name={`${el}.gls.sender_name`}
                                    component={InputField}
                                    type="text"
                                    validate={[validators.required]}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor={`${el}.gls.sender_city`}>City</label>

                                <Field
                                    className="form-control"
                                    name={`${el}.gls.sender_city`}
                                    component={InputField}
                                    type="text"
                                    validate={[validators.required]}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor={`${el}.gls.sender_address`}>Address</label>

                                <Field
                                    className="form-control"
                                    name={`${el}.gls.sender_address`}
                                    component={InputField}
                                    type="text"
                                    validate={[validators.required]}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor={`${el}.gls.sender_zipcode`}>Zip Code</label>

                                <Field
                                    className="form-control"
                                    name={`${el}.gls.sender_zipcode`}
                                    component={InputField}
                                    type="text"
                                    validate={[validators.required]}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor={`${el}.gls.sender_contact`}>Contact Person</label>

                                <Field
                                    className="form-control"
                                    name={`${el}.gls.sender_contact`}
                                    component={InputField}
                                    type="text"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor={`${el}.gls.sender_phone`}>Phone</label>

                                <Field
                                    className="form-control"
                                    name={`${el}.gls.sender_phone`}
                                    component={InputField}
                                    type="text"
                                    validate={[validators.required]}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor={`${el}.gls.sender_email`}>Email</label>

                                <Field
                                    className="form-control"
                                    name={`${el}.gls.sender_email`}
                                    component={InputField}
                                    type="text"
                                    validate={[validators.required, validators.email]}
                                />
                            </div>

                            <h2>GLS Services</h2>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label htmlFor={`${el}.gls.services.T12.enabled`}>
                                        <Field
                                            parse={value => !!value} name={`${el}.gls.services.T12.enabled`} id={`${el}.gls.services.T12.enabled`} component="input" type="checkbox" />Express Service </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label htmlFor={`${el}.gls.services.XS.enabled`}><Field parse={value => !!value} name={`${el}.gls.services.XS.enabled`} id={`${el}.gls.services.XS.enabled`} component="input" type="checkbox" />Exchange Service</label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label htmlFor={`${el}.gls.services.SM1.enabled`}><Field parse={value => !!value} name={`${el}.gls.services.SM1.enabled`} id={`${el}.gls.services.SM1.enabled`} component="input" type="checkbox" />SMS Service</label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label htmlFor={`${el}.gls.services.SM2.enabled`}><Field parse={value => !!value} name={`${el}.gls.services.SM2.enabled`} id={`${el}.gls.services.SM2.enabled`} component="input" type="checkbox" />PreAdvice Service</label>
                                </div>
                            </div>
                        </div>}
                    </CollapsablePanel>

                </section>
                }
            </div>

        </div>);
    }
}


export default Location;


// WEBPACK FOOTER //
// app/containers/Location.jsx